module.exports = __webpack_public_path__ + "img/tb-4.c847a0d3.jpg";